import { render, staticRenderFns } from "./StudyPrograms.vue?vue&type=template&id=72efee6d&scoped=true"
import script from "./StudyPrograms.vue?vue&type=script&lang=ts"
export * from "./StudyPrograms.vue?vue&type=script&lang=ts"
import style0 from "./StudyPrograms.vue?vue&type=style&index=0&id=72efee6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72efee6d",
  null
  
)

export default component.exports